import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import {
  StyledRecipientDetails,
  StyledRecipientWrapper,
} from "./referralForm.styles";
import { AddressInput } from "./styled";
import { TextField } from "@mindlercare/ui-web";

const RecipientDetails = ({ t, formData, onFormFieldChange }) => {
  return (
    <div>
      <StyledRecipientDetails variant="h4">
        {t("RECIPIENT_DETAILS")}
      </StyledRecipientDetails>
      <StyledRecipientWrapper>
        <TextField
          label={t("NAME_OR_CLINIC")}
          onChange={(e) => onFormFieldChange("name_clinic", e.target.value)}
          placeholder={t("ENTER_NAME_OR_CLINIC")}
          value={formData.name_clinic}
          sx={{ width: "100%" }}
          disabled={!formData.type}
          testId="clinicNameInputField"
        />
        <TextField
          label={t("ADDRESS")}
          onChange={(e) => onFormFieldChange("address", e.target.value)}
          value={formData.address}
          as={AddressInput}
          placeholder={t("ENTER_ADDRESS")}
          sx={{ width: "100%" }}
          disabled={!formData.type}
          testId="addressInputField"
        />
      </StyledRecipientWrapper>
    </div>
  );
};

RecipientDetails.propTypes = {
  t: PropTypes.func,
  formData: PropTypes.object,
  onFormFieldChange: PropTypes.func,
};

export default withTranslation()(RecipientDetails);
